<template>
  <scout-tab-panel
    :is-active="isActive"
    title="スカウト済み"
    name="scout"
    :link="link"
    tooltip="掲載期間＋１週間、無料で再スカウトを送信することができます。"
  />
</template>

<script>
import ScoutTabPanel from '@/components/atoms/ScoutTabPanel'

export default {
  components: { ScoutTabPanel },
  computed: {
    isActive () {
      return this.$route.path.includes('/scouted')
    },
    link () {
      return { name: 'scoutScouted' }
    }
  }
}

</script>
